import React, {useState} from 'react';
import {myStorage} from "../../firebase";
import {FaRegAddressCard} from 'react-icons/fa';
import {GiOpenFolder} from 'react-icons/gi';
import {BsPencilSquare} from 'react-icons/bs';

const Form = (props) => {
    const initialFieldValues = { 
        artefactName: '',
        category: '',
        description : ' ',
    }

    var [values, setValues] = useState(initialFieldValues)

    const handleInputChange = e => { 
        var {name, value} = e.target
        setValues({
            ...values,
            [name]:value
        })
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        props.addOrEdit(values)
    }
/*---------------------- UPLOAD FILE -------------------*/
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);

    const handleChange = e => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };

   const handleUpload = () => {
        const uploadTask = myStorage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
            "state_changed",
            snapshot => {
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                setProgress(progress);
                alert("Your image has been uploaded 👍");
            },
            error => {
                console.log(error);
            },
            () => {
                myStorage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
               
            }
        );
    };

    console.log("image: ", image); 
    

    return (
    <div >
       <form autoComplete="off" className ="form" onSubmit={handleFormSubmit}>
           <h1> 
               Contribute
           </h1>
           <h2>
               We believe in the collective endeavor of gathering heritage knowledge and information. 
               We thank you in advance for supporting our effort in preserving the Sarawak's precious cultural heritage.
           </h2>
           <div className="form-inputs"> 
               <i> <FaRegAddressCard/> </i>  
                <label className ="form-label"> Artefact Name </label>      
                <input className="form-input" placeholder="Artefact Name" name="artefactName"
                        value = {values.artefactName} 
                        onChange={handleInputChange} 
                    />
            </div>

           <div className ="form-inputs">
                <i> <GiOpenFolder/> </i>
                <label className ="form-label"> Artefact Category </label>      
                <input className="form-input" placeholder="Category" name="category"
                       value = {values.category}
                       onChange={handleInputChange}
                        />
            </div>

            <div className ="form-inputs">
                <i> <BsPencilSquare/> </i>
                <label className ="form-label"> Description </label>      
                <input className="form-input" placeholder="Tell us more about it..." name="description"
                       value = {values.description}
                       onChange={handleInputChange}
                        />
            </div>

            <p> Note: Please rename your image file in the following format before submitting:  </p>
            <p> [Ethnic]_[Category]_[Name] </p> <br/>

            <progress value={progress} max="100" />
            
            <input className="form-input-image" type="file" onChange={handleChange} />
            <button className="form-input-btn" onClick={handleUpload}>Submit</button>
           
         
       </form>
    </div>
    );
}

export default Form
